import { render, staticRenderFns } from "./ModalCadastrarCliente.vue?vue&type=template&id=936ed866&"
import script from "./ModalCadastrarCliente.vue?vue&type=script&lang=js&"
export * from "./ModalCadastrarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports